.header-ctas .contact-link {
  margin-right: 52px;
}
.wandb-header {
  background-color: #1a1c1f;
  padding: 24px;
  font-family: "Source Sans Pro", sans-serif;
}
.mobile-menu-wrapper {
  font-family: "Source Sans Pro", sans-serif;
}
.mobile-menu-wrapper a {
  text-decoration: none;
}
.wandb-header .container {
  max-width: min(100%, 1392px);
  margin-left: auto;
  margin-right: auto;
}
.wandb-header a {
  text-decoration: none;
}
.yellow-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background-image: linear-gradient(270deg, #ffcc33 50%, #ffad33 100%);
  border-radius: 8px;
  color: #1a1c1f;
  text-transform: uppercase;
  padding: 14px 22px;
  font-family: "Source Sans Pro", sans-serif;
  font-size: 16px;
  font-weight: 600;
  letter-spacing: 0.96px;
}
.yellow-btn:hover {
  background-image: linear-gradient(180deg, #ffcc33 0%, #ffcc33 100%);
}
.header-ctas a:not(.yellow-btn) {
  display: inline-flex;
  color: #fbfbfc;
  text-transform: uppercase;
  font-family: "Source Sans Pro", sans-serif;
  font-size: 16px;
  font-weight: 400;
  letter-spacing: 0.96px;
  margin-right: 12px;
}
.header-ctas a:not(.yellow-btn):hover {
  color: #ffcc33;
}
.wandb-header .yellow-btn {
  margin-left: 12px;
}
.header-ctas {
  display: inline-flex;
  align-items: center;
  gap: 12px;
}
.header-ctas .profile-menu,
.header-ctas .search-nav {
  position: static;
}
.header-cols {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: center;
}
.header-left {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
}
.header-logo {
  max-width: 245px;
}
.header-logo img {
  display: block;
  max-width: 100%;
  height: auto;
}
.wandb-nav ul {
  list-style-type: none;
  margin: 0 0 0 36px;
  padding: 0;
}
.wandb-nav > ul {
  display: flex;
}
.wandb-nav > ul > li {
  display: flex;
  align-items: center;
  position: relative;
}
.wandb-nav > ul > li.wb-menu-has-children {
  padding-right: 22px;
}
.wandb-nav > ul > li.wb-menu-has-children:after {
  position: absolute;
  content: "";
  display: block;
  width: 16px;
  height: 16px;
  background: url("./assets/dropdown-icon.svg") no-repeat center
    center;
  background-size: contain;
  right: 0;
  top: 50%;
  transform: translateY(-50%);
  opacity: 0.4;
}
.wandb-nav > ul > li > .wb-menu-item {
  color: #fbfbfc;
  font-family: "Source Sans Pro", sans-serif;
  font-weight: normal;
  font-size: 16px;
}
.wandb-nav > ul > li:not(:last-child) {
  margin-right: 36px;
}
.wandb-sub-nav.two-columns {
  display: flex;
  justify-content: space-between;
}
.wandb-sub-nav.two-columns > ul {
  min-width: 200px;
}
.wandb-sub-nav.two-columns > ul:first-child {
  padding-right: 30px;
  border-right: 1px solid #34373c;
}
.wandb-sub-nav.two-columns > ul:last-child {
  padding-left: 30px;
}
.wandb-sub-nav.four-columns > ul:not(.wandb-nav-bottom-fw) {
  width: 24%;
  flex-shrink: 0;
}
.wandb-sub-nav.three-columns.four-columns > ul.wandb-nav-bottom-fw {
  width: 100% !important;
  background: #1a1c1f;
  border-radius: 1rem;
  padding: 1rem;
  margin-top: 16px;
}
ul.wandb-nav-bottom-fw .wandb-nav-sub-items {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
}
.wandb-nav-bottom-fw .wandb-nav-sub-title {
  line-height: 1.4;
  margin-bottom: 10px;
}
.wandb-nav > ul > li:hover > .wb-menu-item {
  color: #ffcc33;
}
.wandb-nav > ul > li > span.wb-menu-item {
  cursor: default;
}
.wandb-sub-nav {
  position: absolute;
  top: 100%;
  left: -30px;
  transform: translate(0, 20px);
  border: 1px solid #34373c;
  border-radius: 8px;
  background: #212429;
  padding: 24px;
  line-height: 1;
  opacity: 0;
  visibility: hidden;
  white-space: nowrap;
  z-index: 1000;
  transition: all 0.2s ease-in-out;
}
.wandb-nav > ul > li:hover .wandb-sub-nav {
  opacity: 1;
  visibility: visible;
  transform: translate(0, 0);
}
.wandb-sub-nav:before {
  content: "";
  display: block;
  width: 100%;
  height: 20px;
  position: absolute;
  bottom: 100%;
  left: 0;
}
.wandb-sub-nav ul {
  list-style-type: none;
  margin: 0;
  padding: 0;
  min-width: 110px;
}
.wandb-sub-nav a {
  display: flex;
  align-items: center;
  padding: 9px 1px;
  color: #fff;
  transition: 0.4s;
}
.wandb-sub-nav a:hover {
  color: #00afc2;
}
.wandb-sub-nav.allow-paddings a {
  padding: 16px 1px;
  font-size: 20px;
}
.wandb-nav-sub-title,
.wandb-sub-nav h5 {
  font-family: "Source Sans Pro", Sans-serif;
  color: #fff;
  font-size: 26px;
  font-weight: 600;
  line-height: 20px;
  margin: 0 0 16px;
}
.wandb-nav-sub-title {
  color: #dadee3;
  font-weight: 600;
  margin-bottom: 24px;
}
.wbnav-icon-list-item {
  display: flex;
  align-items: center;
  margin-top: 8px;
  padding-bottom: 8px;
}
.wbnav-icon-list-item a {
  white-space: normal;
  display: flex;
  align-items: center;
}
.wbnav-icon-list-icon {
  width: 35px;
  min-width: 35px;
  margin-right: 5px;
}
.wbnav-icon-list-icon svg {
  display: block;
  width: 100%;
  height: auto;
}
.wbnav-icon-list-text {
  padding-left: 5px;
  font-size: 14px;
  font-weight: 600;
}
.wbnav-icon-list-text span {
  font-size: 12px;
  font-weight: 400;
  line-height: 1;
  color: #dadee3;
  padding: 8px 0 0;
  display: block;
}
.wandb-sub-nav.three-columns {
  width: 1307px;
  left: -250px;
  padding: 40px;
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  max-width: calc(100vw - 100px);
}
.wandb-sub-nav.three-columns.allow-paddings {
  width: 1153px;
  left: -250px;
}
.wandb-sub-nav.three-columns.allow-paddings > ul:nth-child(1) {
  width: 245px;
}
.wandb-sub-nav.three-columns.allow-paddings > ul:nth-child(2) {
  width: 260px;
}
.wandb-sub-nav.three-columns.allow-paddings > ul:nth-child(3) {
  width: 450px;
}
.wandb-sub-nav.three-columns > ul {
  width: 32.7%;
}
.wandb-sub-nav.three-columns > ul:nth-child(2) {
  width: 26.5%;
}
.wandb-sub-nav.allow-paddings {
  padding: 32px 40px;
}
.wandb-sub-nav.allow-paddings ul li h5 {
  padding-bottom: 16px;
  margin-bottom: 16px;
}
.wandb-sub-nav.allow-paddings ul li a {
  padding: 8px 0;
}
.wandb-sub-nav.three-columns:not(.allow-paddings) a {
  padding: 0;
}
.wandb-sub-nav.three-columns.allow-paddings > ul:nth-child(3) a {
  padding-top: 12px;
  padding-bottom: 12px;
  display: flex;
  align-items: center;
}
.wandb-sub-nav.three-columns.allow-paddings
  > ul:nth-child(3)
  a
  span:first-child {
  width: 55px;
  margin-right: 10px;
}
.wandb-sub-nav.three-columns.allow-paddings
  > ul:nth-child(3)
  a
  span:nth-child(2)
  span {
  display: block;
  font-size: 16px;
  color: #dadee3;
  padding: 12px 0 0;
}
.wandb-sub-nav.single-column {
  width: auto;
  min-width: 180px;
}
.wandb-sub-nav.single-column ul {
  width: 100%;
}
.mobile-menu-toggle {
  background: transparent;
  border-radius: 8px;
  border: 1px solid #adb0b5;
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  padding: 0;
}
.mobile-menu-toggle img {
  width: 20px;
  height: auto;
}
body:not(.show-mobile-menu) .mobile-menu-toggle .close-icon {
  display: none;
}
body.show-mobile-menu .mobile-menu-toggle .menu-icon {
  display: none;
}
.wandb-nav-sub-title,
.wandb-sub-nav h5 {
  padding-bottom: 0;
  display: flex;
  align-items: center;
  font-size: 20px;
  background: linear-gradient(180deg, #ffcc33 43.61%, #ffad33 81.32%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  text-fill-color: transparent;
}
.wandb-nav-sub-title a,
.wandb-sub-nav h5 a {
  display: flex;
  align-items: center;
}
.wandb-nav-sub-title svg,
.wandb-sub-nav h5 svg {
  margin-left: 16px;
  width: 8px;
}
@media all and (max-width: 1280px) {
  .header-logo {
    width: 180px;
  }
  .wandb-nav > ul {
    margin-left: 16px;
  }
  .wandb-nav > ul > li:not(:last-child) {
    margin-right: 18px;
  }
  .wandb-nav > ul > li > .wb-menu-item {
    font-size: 15px;
  }
  .header-ctas a,
  .yellow-btn {
    font-size: 14px;
  }
  .yellow-btn {
    padding: 12px 16px;
  }
  .wandb-sub-nav.three-columns {
    left: -200px;
  }
}
@media all and (min-width: 1001px) {
  .wb-header-hidden-desktop {
    display: none !important;
  }
}
@media all and (max-width: 1000px) {
  .wb-header-hidden-mobile {
    display: none !important;
  }
}
.mobile-menu-wrapper {
  display: none;
}
.mobile-menu-inner {
  background: #1a1c1f;
  height: 100%;
  width: 100%;
  overflow-y: auto;
  padding: 20px;
}
.mobile-menu-item {
  margin-bottom: 20px;
}
.mobile-menu-item a,
.mobile-menu-item .mobile-menu-dropdown-trigger {
  color: #fbfbfc;
  font-size: 18px;
  font-weight: 500;
  padding: 15px 0;
  display: block;
  background: none;
  border: none;
  width: 100%;
  text-align: left;
  cursor: pointer;
  font-family: inherit;
}
.mobile-menu-item a:hover,
.mobile-menu-item .mobile-menu-dropdown-trigger:hover {
  color: #ffcc33;
}
.mobile-menu-buttons {
  margin-top: 30px;
}
.mobile-menu-buttons a {
  display: block;
  margin-top: 16px;
  text-align: center;
  padding: 16px;
  border-radius: 8px;
}
body.show-mobile-menu .mobile-menu-wrapper {
  opacity: 1;
  visibility: visible;
  transform: none;
  display: block;
}
.mobile-menu-dropdown-trigger {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  padding: 18px 0;
  border: none;
  background: none;
  color: #fbfbfc;
  font-size: 20px;
  font-weight: 600;
  outline: none;
  cursor: pointer;
}
.mobile-menu-dropdown-trigger img {
  transition: transform 0.2s ease;
  opacity: 0.6;
}
.mobile-menu-dropdown-trigger img.rotate-180 {
  transform: rotate(180deg);
}
.mobile-menu-item ul {
  list-style: none;
  margin: 0;
  padding: 0;
}
.mobile-menu-item ul li {
  position: relative;
  padding: 12px 0;
}
.mobile-menu-item.has-sub-nav > a {
  position: relative;
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: #fbfbfc;
  font-size: 24px;
  font-weight: 600;
}
.mobile-menu-item.has-sub-nav > a:after {
  content: "";
  display: block;
  width: 16px;
  height: 16px;
  opacity: 0.4;
  background: url("./assets/dropdown-icon.svg") no-repeat center;
  background-size: contain;
  transition: transform 0.3s ease;
}
.mobile-menu-item.has-sub-nav.open > a:after {
  transform: rotate(180deg);
}
.wb-sub-items-wrapper {
  background: #212429;
  border-radius: 20px;
  padding: 20px;
  margin-top: 10px;
}
.mobile-menu-section {
  margin-bottom: 24px;
}
.mobile-menu-section .wandb-nav-sub-title {
  color: #ffffff !important;
  font-family: "Source Sans Pro", Sans-serif !important;
  font-size: 24px !important;
  font-weight: 400 !important;
  line-height: 20px !important;
  margin: 0 0 16px 0 !important;
  padding: 0 0 9px 0 !important;
  border-bottom: 1px solid #34373c;
}
.mobile-menu-section .wandb-nav-sub-title a {
  color: #ffffff !important;
  font-family: "Source Sans Pro", Sans-serif !important;
  font-size: 24px !important;
  font-weight: 400 !important;
  line-height: 20px !important;
  text-decoration: none !important;
  display: flex;
  align-items: center;
}
.mobile-menu-section-items {
  list-style: none;
  margin: 0;
  padding: 0;
}
.mobile-menu-item-with-icon {
  margin-bottom: 4px;
  border-bottom: none;
}
.mobile-menu-item-with-icon > a {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  padding: 8px 1px;
  text-decoration: none;
  color: #fbfbfc;
}
.mobile-menu-item-icon {
  flex-shrink: 0;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #34373c;
}
.mobile-menu-item-icon img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.mobile-menu-item-content {
  flex: 1;
}
.mobile-menu-item-title {
  font-size: 16px;
  font-weight: 600;
  color: #fbfbfc;
  margin-bottom: 4px;
}
.mobile-menu-item-description {
  font-size: 16px;
  color: #dadee3;
  line-height: 1.4;
}
.wb-sub-items-wrapper {
  background: #212429;
  border-radius: 20px;
  padding: 20px;
  margin-top: 10px;
}
